import React, { Fragment } from "react";
import PropTypes from "prop-types";
import ProductsTile from "./ProductsTile";
import { BarLoader } from "react-spinners";

class Products extends React.Component {
    render() {
        const ln = this.props.products.length;
        return (
            <Fragment>
                <div className="tiles-container">
                    <nav role="navigation" className="tile-row">
                        {ln > 0 ? (
                            this.props.products
                                .sort(function(a, b) {
                                    let initial = a.name.toLowerCase(),
                                        next = b.name.toLowerCase();
                                    if (initial < next) return -1;
                                    if (initial > next) return 1;
                                    return 0;
                                })
                                .map((products, i) => (
                                    <ProductsTile
                                        {...this.props}
                                        i={i}
                                        key={i}
                                        type={"products"}
                                        products={products}
                                    />
                                ))
                        ) : (
                            <div className="spinner-holder">
                                <BarLoader color={"#150F96"} />
                            </div>
                        )}
                    </nav>
                </div>
            </Fragment>
        );
    }
}

export default Products;



// WEBPACK FOOTER //
// ./src/components/Products.js